import React, { FC } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormLabel from './FormLabel';

interface IFormRowGroupProps {
  label?: string;
  children: React.ReactNode;
  tooltip?: string;
  isRequired?: boolean;
}

const FormRowGroup: FC<IFormRowGroupProps> = ({ label, isRequired, tooltip, children }) => {
  return (
    <Row>
      <FormLabel
        label={label || ''}
        isRequired={isRequired}
        tooltip={tooltip}
        isHorizontal
      />
      <Col sm={6}>
        <Row>{children}</Row>
      </Col>
    </Row>
  );
};

export default FormRowGroup;
